export const spaceGroupsApiErrorsTranslations = {
  RESOURCE_ALREADY_EXISTS:
    'spaceGroups:common.editNameDialog.resourceAlreadyExists',
  SPACE_GROUP_STILL_ASSIGNED_TO_SPACE:
    'spaceGroups:common.deleteGroupDialog.spaceGroupStillAssignedToSpace',
  SPACE_GROUP_STILL_ASSIGNED_TO_EMPLOYEE_GROUP:
    'spaceGroups:common.deleteGroupDialog.spaceGroupStillAssignedToEmployeeGroup',
} as const;
